import { render } from "./GiDetail.vue?vue&type=template&id=24d0882a"
import script from "./GiDetail.vue?vue&type=script&lang=js"
export * from "./GiDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__